import { useEffect } from "react";

import {
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useController } from "react-hook-form";
import {
  FlagImage,
  defaultCountries,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import "react-international-phone/style.css";

import { ReactComponent as Arrow } from "../../../Assets/Images/ArrowDown.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import Label from "./Label";

export const PhoneNumber = ({
  setValue,
  label,
  required,
  value,
  values,
  control,
  name,
  ...restProps
}) => {
  const { country, setCountry } = usePhoneInput({
    defaultCountry: values.phoneNumberCountryCode || "lk",
    value,
    countries: defaultCountries,
    onChange: (data) => {
      setValue("phoneNumberCountryCode", data?.country?.iso2?.trim());
      setValue("phoneNumberDialCode", data?.phone?.trim());
    },
  });
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  useEffect(() => {
    setCountry(values.phoneNumberCountryCode);
  }, [values.phoneNumberCountryCode]);
  const formatPhoneNumber = (phoneNumber) => {
    //:FIX : need to add spaces while typing

    // Check if the input is a valid 10-digit phone number
    // if (!/^\d{10}$/.test(phoneNumber)) {
    //   // If not, return the original input
    //   return phoneNumber;
    // }

    // Format the phone number
    const formattedNumber = phoneNumber?.replace(
      /(\d{2})(\d{4})(\d{4})/,
      "$1 $2 $3",
    );

    return formattedNumber;
  };
  const formattedValue = formatPhoneNumber(field?.value);
  const outlinedSelectors = [
    "& .MuiOutlinedInput-notchedOutline",
    "&:hover .MuiOutlinedInput-notchedOutline",
    "&:focus-visible .MuiOutlinedInput-notchedOutline",
    // "&.MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root .fieldset:hover",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline",
  ];
  return (
    <FormItemsWrap>
      <Label label={label} required={required} />
      <TextField
        {...field}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={formattedValue}
        variant="outlined"
        color="primary"
        placeholder="Phone number"
        type="tel"
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              style={{
                // place blue comp in select,
                marginLeft: "-14px",
              }}
            >
              <Select
                IconComponent={Arrow}
                MenuProps={{
                  // styles for menu drop down with flag country names and dial code
                  style: {
                    height: "300px",
                    width: "325px",
                    top: "10px",
                    left: "-25px",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                sx={{
                  height: "50px",
                  [outlinedSelectors.join(",")]: {
                    height: "0px",
                    display: "none",
                  },
                  width: "90px",
                  "& fieldset": {
                    fontSize: "13px",
                    border: "none",
                    borderRadius: "7px 0px 0px 7px !important",
                    "&:hover": {
                      border: "none",
                      borderRadius: "0px !important",
                      WebkitBorderRadius: "0px !important",
                    },
                    "&:focus": {
                      border: "none",
                      borderRadius: "0px !important",
                      WebkitBorderRadius: "0px !important",
                    },
                  },
                  backgroundColor: "rgba(229, 242, 255, 0.50)",
                  borderRight: "1px solid #E5E5EA",
                  borderRadius: "7px 0px 0px 7px",
                  WebkitBorderRadius: "7px 0px 0px 7px",
                  svg: {
                    top: "50%",
                  },
                  ".MuiSelect-icon": {
                    top: "calc(54% - .5em)",
                  },
                }}
                value={country.iso2}
                onChange={(e) => {
                  setValue("phoneNumberCountryCode", e.target.value);
                  setCountry(e.target.value);
                }}
                renderValue={(value) => (
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <FlagImage
                      iso2={value}
                      style={{
                        backgroundSize: "fit",
                        borderRadius: "100%",
                        backgroundColor: "white",
                        height: "14px",
                        width: "14px",
                      }}
                    />
                    <p
                      style={{
                        color: "#747474",
                        fontSize: 12,
                        fontWeight: "400",
                        wordWrap: "break-word",
                      }}
                    >
                      {values.phoneNumberDialCode}
                    </p>
                  </div>
                )}
              >
                {defaultCountries.map((c) => {
                  const country = parseCountry(c);
                  return (
                    <MenuItem
                      sx={{ height: "30px" }}
                      key={country.iso2}
                      value={country.iso2}
                    >
                      <FlagImage
                        iso2={country.iso2}
                        style={{ marginRight: "8px" }}
                      />
                      <Label
                        fontSize={"12px"}
                        label={country.name}
                        marginRight="8px"
                      />

                      <Typography fontSize={"12px"} color="#747474">
                        +{country.dialCode}
                      </Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ),
        }}
        {...restProps}
      />
    </FormItemsWrap>
  );
};
